import React from 'react'

// Each box here is a standalone true/false, never one member of a checkbox
// group, so the input must not carry a group value. Formik decides between the
// two on the DOM value: anything non-empty (the field's own value via {...field},
// or the "on" a value-less checkbox reports) makes it maintain an array, and
// unticking then stores [] -- which is truthy, so the box could never clear.
// An empty value keeps Formik on its boolean path.
export const Checkbox = ({isSelected, onChange, label, field, extraText, extraClass}: any) => {
  const {value, ...fieldProps} = field ?? {}
  return (
    <>
      {extraText && <p className='text-muted font-weight-lighter'>{extraText}</p>}
      <div className={`form-check form-check-sm form-check-custom form-check-solid ${extraClass}`}>
        <input
          className='form-check-input'
          type='checkbox'
          checked={isSelected}
          onChange={onChange}
          {...fieldProps}
          value=''
        />
      </div>
    </>
  )
}
